// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__cqEAW","footerNav":"Footer_footerNav__oMKFP","footerLink":"Footer_footerLink__zoJJ6","copyright":"Footer_copyright__JQMtz"};